'use client'
import { useEffect, useState } from 'react'
import Image from 'next/image'
import { useRouter } from 'next/navigation'
import Cookies from 'js-cookie'
import GradientBorderButton from '@/Component/Common/Forms/GradientBorderButton'
import GradientButton from '@/Component/Common/Forms/GradientButton'
import { useTranslation } from '@/Utils/Hooks/useTranslate'

const PublishCampaign = () => {
    const router = useRouter();
    const {translations} = useTranslation();
    const [slug, setSlug] = useState('');

    useEffect(() => {
        const campaignSlug = Cookies.get('campaign_slug');
        if(campaignSlug){
            setSlug(campaignSlug);
        } else{
            router.push('/brand/my-campaigns')
        }
    }, [])

    const handleReturnToDashboard = () => {
        router.push('/brand/my-campaigns');
        Cookies.remove('campaign_slug');
    }

    const handleSearchInfluencer = () => {
        // router.push(`/brand/my-campaigns/${slug}`)
        router.push(`/brand/my-campaigns/${slug}?tab=Influencer%20Pool`)
        Cookies.remove('campaign_slug');
    }

    return (
        <div className='h-full flex items-center justify-center flex-col'>
            <Image src='/assets/images/approval-check.png' alt='publish' width={100} height={100} className='mb-6' />
            <h1 className='md:text-4xl text-2xl font-semibold mb-2.5 leading-10'>{translations?.campaignPublished}</h1>
            <span className='text-gray md:text-xl text-lg font-medium text-center'>{translations?.campaignPublishedMessage}</span>
            <div className='md:mt-10 mt-5 flex items-center gap-4'>
                <GradientButton title={translations?.campaignPublishedButtonText} buttonType='button' onClick={handleReturnToDashboard} customClass='!rounded-xl px-5 !w-48' parentClass='!rounded-xl' />
            </div>
        </div>
    )
}

export default PublishCampaign
